import { Button, Container, Icon, Input, Typography } from '@design-system';
import React from 'react';
import './InputDropdownMulti.scss';
import { IoMdClose } from 'react-icons/io';
import { useInputDropdownMulti } from './useInputDropdownMulti';

interface Option {
    id: string;
    label: string;
}

export type InputDropdownMultiProps = {
    placeholder?: string;
    onOptionChange: (selectedOptions: Option[]) => void;
    value?: Option[];
    disabled?: boolean;
};

export const InputDropdownMulti: React.FC<InputDropdownMultiProps> = ({ placeholder, onOptionChange, value = [], disabled = false }) => {
    const { inputValue, handleInputChange, handleKeyDown, handleRemoveItem, dynamicPlaceholder } = useInputDropdownMulti({
        placeholder,
        onOptionChange,
        value
    });

    return (
        <div className="input-dropdown-multi">
            <Input
                type="text"
                placeholder={dynamicPlaceholder}
                value={inputValue}
                onValueChange={(value: string) => handleInputChange(value)}
                disabled={disabled}
                className="dropdown-input"
                onKeyDown={handleKeyDown}
            />

            {value.length > 0 && (
                <Container className="selected-items" padding="none">
                    {value.map((item) => (
                        <Container key={item.id} className="selected-item" bordered="grey" padding="small-medium">
                            <div className="selected-item-icon">
                                <Typography intrinsic="p" color="marine">
                                    {item.label}
                                </Typography>
                            </div>
                            <Button
                                type="button"
                                className="remove-button"
                                onClick={() => handleRemoveItem(item)}
                                color="marine"
                                variant="tertiary"
                            >
                                <Icon icon={<IoMdClose />} size={20} color="marine" />
                            </Button>
                        </Container>
                    ))}
                </Container>
            )}
        </div>
    );
};
